import React from 'react';

export default function CabifyIcon() {
  return (
    <svg width="20" height="22" viewBox="0 0 18 22">
      <path d="M8.87,6.07A2.91,2.91,0,0,1,11,7a2.92,2.92,0,0,0,4.19,0,3.12,3.12,0,0,0,0-4.3A8.78,8.78,0,0,0,8.87,0,9,9,0,0,0,0,9.11a9.22,9.22,0,0,0,2.6,6.44L8.87,22l6.27-6.44a3.12,3.12,0,0,0,0-4.3,2.92,2.92,0,0,0-4.19,0L8.87,13.41,6.78,11.26a3.07,3.07,0,0,1-.86-2.14A3,3,0,0,1,8.87,6.07ZM5.74,12.34l3.14,3.23L12,12.34a1.45,1.45,0,0,1,2.08,0,1.55,1.55,0,0,1,0,2.14L8.88,19.86,3.64,14.49A7.73,7.73,0,0,1,1.48,9.11,7.49,7.49,0,0,1,8.87,1.52,7.32,7.32,0,0,1,14.1,3.74a1.55,1.55,0,0,1,0,2.14,1.45,1.45,0,0,1-2.08,0A4.38,4.38,0,0,0,8.87,4.55,4.5,4.5,0,0,0,4.43,9.11,4.64,4.64,0,0,0,5.74,12.34Z" />
    </svg>
  );
}



// WEBPACK FOOTER //
// ./src/components/icons/CabifyIcon/index.js